const fr = {
  header: {
    wash: 'Laver',
    insurance: 'Assurance',
    shop: 'Boutique',
    premium: 'Premium',
    aboutUs: 'À propos',
    help: 'Aide',
    sendToPhone: 'Envoyer sur mon téléphone'
  },
  common: {
    title: 'Neatcar LiveMap',
    buyAWash: 'Acheter un lavage',
    moreDetails: 'Plus de détail',
    Activities: 'Activités',
    Washes: 'Lavages',
    price: '{{price}}$',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD',
    inAppPrices: 'Prix dans l\'application',
    reportedBy: 'Reporté par',
    buyFromPhone: 'Achetez vos lavages depuis votre téléphone',
    sendToPhone: 'Envoyer sur mon téléphone',
    sendToPhoneDesc: 'Envoyez le lien de téléchargement sur votre téléphone',
    downloadApp: 'Télécharger l\'application Neatcar',
    appStoreLink: 'https://apps.apple.com/ca/app/neatcar/id1499030487?l=fr',
    playStoreLink: 'https://play.google.com/store/apps/details?id=com.mecommerce.carwashremote&hl=fr_CA',
    scanTheCode: 'Scannez le code avec votre téléphone',
    scanTheCodeDesc: 'Utilisez l\'appareil photo de votre téléphone pour scanner et télécharger l\'application Neatcar.',
    phoneRequired: 'Le numéro de téléphone est requis',
    download: 'Télécharger',
    downloadDesc: 'Télécharger l\'application Neatcar sur votre téléphone depuis le',
    choose: 'Choisissez votre station',
    chooseDesc: 'Choisissez votre station parmis bos partenaires et sélectionnez le type de lavage souhaité',
    pay: 'Acheter',
    payDesc: 'Une fois votre type de lavage choisi, achetez le depuis l\'application et utiliser le code directement au lave-auto',
    
    // Store detail specific
    carWash: 'Lave-Auto',
    carWashStation: 'Station de lavage auto',
    realTimeAvailability: 'Disponibilité en temps réel sur la carte Neatcar.',
    contactCarWash: 'Lave-Auto avec Contact',
    touchlessCarWash: 'Lave-Auto sans Contact',
    closePanel: 'Fermer le panneau',
    discount: 'Rabais',
    locatedAt: 'situé au',
    promoCode: 'Code Promo',
    freeTrialOffer: '3 mois Premium GRATUIT'
  },
  seo: {
    // Main page SEO
    mainTitle: 'Carte Neatcar - Stations de Lavage Auto Québec',
    mainDescription: 'Découvrez les stations de lavage auto près de chez vous avec la carte interactive Neatcar. Disponibilité en temps réel, prix et emplacements au Québec et partout au Canada.',
    mainKeywords: 'lave-auto, lavage auto, neatcar, carte interactive, station de lavage auto, mon lave-auto, lave-auto près de moi, lavage sans contact, québec, canada, carte lave-auto',
    
    // Dynamic SEO content
    stationsText: 'Stations de Lavage Auto',
    findText: 'Trouvez',
    mapText: 'Carte interactive avec disponibilité en temps réel et navigation.',
    pricesFromText: 'Prix de',
    toText: 'à',
    checkPricingText: 'Vérifiez les prix en temps réel.',
    acrossText: 'à travers',
    canadaText: 'le Canada',
    inText: 'au',
    fromText: 'de',
    
    // Store detail SEO
    storeTitle: 'Lave-auto {{brandName}} – {{streetName}}, {{city}} | Carte Neatcar',
    storeDescription: 'Lave-auto {{brandName}} sur {{streetName}} à {{city}}. Voir les prix et la disponibilité en direct.',
    storeKeywords: '{{brandName}}, lave-auto, lavage auto, {{address}}, {{city}}, {{province}}, neatcar, station service, sans contact',
    
    // Keywords for different contexts
    keywords: {
      base: ['lave-auto', 'lavage auto', 'neatcar', 'carte interactive', 'lave-auto près de moi', 'lavage sans contact', 'canada', 'disponibilité temps réel', 'station service', 'station lavage', 'carte en direct', 'station de lavage auto', 'mon lave-auto', 'carte lave-auto'],
      location: ['lave-auto {{province}}', '{{province}} stations lavage', 'lavage auto {{province}}', 'lave-auto québec', 'station lavage {{province}}', 'carte lave-auto {{province}}'],
      brand: ['{{brand}} lave-auto', '{{brand}} station', 'lave-auto {{brand}}', '{{brand}} station lavage']
    }
  }
};
export default fr;
